import Vue from 'vue'
import Router from 'vue-router'
import multiguard from 'vue-router-multiguard'
import Welcome from '@/components/Welcome'
import SignIn from '@/components/User/SignIn'
import ResetPassword from '@/components/User/ResetPassword'
import Settings from '@/components/Settings'
import CustomerSelect from '@/components/Customer'
import Admin from '@/components/Admin'
import Supplier from '@/components/Supplier'
import Calendar from '@/components/Calendar'
import Project from '@/components/Project'
import Jobs from '@/components/Jobs'
import Import from '@/components/Import'
import NewOrder from '@/components/NewOrder'
import OrderApproval from '@/components/OrderApproval'
import Products from '@/components/Products'
import Finance from '@/components/Finance'
import Sites from '@/components/Sites'
import Contacts from '@/components/Contacts'
import ServiceCalls from '@/components/ServiceCalls'
import BulkSMS from '@/components/BulkSMS'
import SIMS from '@/components/SIMS'
import AuditLog from '@/components/AuditLog'
import Devices from '@/components/Devices'
import AuthGuard from './AuthGuard'
import NotAuthGuard from './NotAuthGuard'
import ViewAllJobsGuard from './ViewAllJobsGuard'
import SupplierGuard from './SupplierGuard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/SignIn',
      name: 'SignIn',
      component: SignIn,
      beforeEnter: NotAuthGuard
    },
    {
      path: '/ResetPassword/:initialEmail',
      name: 'ResetPassword',
      props: true,
      component: ResetPassword
    },
    {
      path: '/',
      name: 'Welcome',
      component: Welcome,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: AuthGuard
    },
    {
      path: '/customer',
      name: 'Customer',
      component: CustomerSelect,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/Jobs',
      name: 'Jobs',
      component: Jobs,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/Products/:customer?/:product?/:vehicle?',
      name: 'Products',
      component: Products,
      props: true,
      beforeEnter: SupplierGuard
    },
    {
      path: '/Admin/:type?',
      name: 'Admin',
      component: Admin,
      props: true,
      beforeEnter: SupplierGuard
    },
    {
      path: '/BulkSMS',
      name: 'BulkSMS',
      component: BulkSMS,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/SIMS',
      name: 'SIMS',
      component: SIMS,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/Devices/:customer?/:vehicle?',
      name: 'Devices',
      component: Devices,
      props: true,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/Supplier/:supplier?',
      name: 'Supplier',
      component: Supplier,
      props: true
    },
    {
      path: '/Calendar/:Supplier',
      name: 'SupplierCalendar',
      component: Calendar,
      props: true
    },
    {
      path: '/Calendar',
      name: 'Calendar',
      component: Calendar,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/Project/:customer?/:job?',
      name: 'Project',
      component: Project,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard]),
      props: true
    },
    {
      path: '/Finance/:customer?',
      name: 'Finance',
      component: Finance,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard]),
      props: true
    },
    {
      path: '/NewOrder',
      name: 'NewOrder',
      component: NewOrder,
      beforeEnter: SupplierGuard
    },
    {
      path: '/Sites',
      name: 'Sites',
      component: Sites,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/ServiceCalls',
      name: 'ServiceCalls',
      component: ServiceCalls,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/Contacts',
      name: 'Contacts',
      component: Contacts,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/Import',
      name: 'Import',
      component: Import,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    },
    {
      path: '/OrderApproval/:ctnSheetProp?',
      name: 'OrderApproval',
      component: OrderApproval,
      props: true,
      beforeEnter: SupplierGuard
    },
    {
      path: '/AuditLog',
      name: 'AuditLog',
      component: AuditLog,
      beforeEnter: multiguard([ViewAllJobsGuard, SupplierGuard])
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js